import { render } from "./SignupLogin.vue?vue&type=template&id=81f6a2f2"
import script from "./SignupLogin.vue?vue&type=script&lang=js"
export * from "./SignupLogin.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__